/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * This class provides a base class for making HTTP requests with Angular's `HttpClient`.
 */
export class HttpClientBase {
  constructor(private http: HttpClient) {}

  protected post<T>(
    payload: any | FormData,
    url: string,
    params?: any,
  ): Observable<T> {
    return this.http.post<T>(url, payload, { params });
  }

  protected get<T>(url: string, params?: any): Observable<T> {
    return this.http.get<T>(url, { params });
  }

  protected put<T>(payload: any, url: string, params?: any): Observable<T> {
    return this.http.put<T>(url, payload, { params });
  }

  protected patch<T>(payload: any, url: string, params?: any): Observable<T> {
    return this.http.patch<T>(url, payload, { params });
  }

  protected delete<T>(url: string, params?: any): Observable<T> {
    return this.http.delete<T>(url, { params });
  }
}
